import { createAsyncThunk } from '@reduxjs/toolkit';

import { AtashsooziOmumiHttpGetService } from 'Feature/Atashsoozi/Services/AtashsooziHttpServices';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import {
  IGetAtashsooziOmumiBimehNamehByShomarehBimehNamehQuery,
  IGetBimehNamehAtashsooziOmumiPrintQuery,
} from '../Models/IGetBimehNamehAtashsooziOmumiPrintQuery';

export const printBimehNamehAtashsooziOmumi = createAsyncThunk(
  'AtashsooziOmumiPrint/printBimehNamehAtashsooziOmumi',
  async (query: IGetBimehNamehAtashsooziOmumiPrintQuery) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${_apiPathManagerConfig?.AtashsooziOmumi.BimehNameh.PrintBimehNamehAtashsooziOmumi}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export const GetAtashsooziOmumiBimehNamehByShomarehBimehNameh = createAsyncThunk(
  'AtashsooziOmumiBimehNamehDetail/GetAtashsooziOmumiBimehNamehByShomarehBimehNameh',
  async (query: IGetAtashsooziOmumiBimehNamehByShomarehBimehNamehQuery) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${_apiPathManagerConfig?.AtashsooziOmumi.BimehNameh.GetAtashsooziBimehNamehByShomarehBimehNameh}`,
      params: query,
    });
  }
);
